import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonTitle from '../../../common-components/common-title';
import CommonUsualText from '../../../common-components/common-usual-text';
import CommonOlList from '../../../common-components/common-ol-list';

const taskList = {
    colorNumber: '#009bcc',
    list: [
        'Создать личные кабинеты для стартаперов, отраслевых экспертов и&nbsp;представителей корпораций',
        `Создать лендинги для акселераторов <a class="gens__link" target="_blank" rel="noopener noreferrer nofollow" href="https://airbus.generation-startup.ru/">Airbus</a>, <a target="_blank" rel="noopener noreferrer nofollow" class="gens__link" href="https://vtb.generation-startup.ru/">ВТБ</a>, <a rel="noopener noreferrer nofollow" target="_blank" class="gens__link" href="https://michelin.generation-startup.ru/">Michelin</a>, <a rel="noopener noreferrer nofollow" target="_blank" class="gens__link" href="https://unilever.generation-startup.ru/">Unilever</a> и др.`,
        'Реализация сложных технологических форм по техническому заданию команды GenerationS на основе требований акселератора',
        'Создать инструмент для&nbsp;экспертизы проектов по&nbsp;бизнес и&nbsp;технологическому сценарию',
        'Создать платформу для коммуникации экспертов и&nbsp;стартапов для совместной работой над заявкой',
        'Провести полный редизайн проекта в&nbsp;2019 году',
        'Провести интеграцию проекта в&nbsp;Цифровую платформу РВК',
    ],
};

const Task = () => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={50} animateOnce={true} duration={1}>
            <FullWrapper className="gens-task" smallPaddings={true} isMargin={false}>
                <div className="gens-task__wrapper">
                    <div className="gens-task__info">
                        <CommonTitle>Задача</CommonTitle>
                        <CommonUsualText className="gens-task__text">
                            Чтобы создать платформу для&nbsp;проведения отбора в&nbsp;корпоративные
                            акселераторы крупнейших мировых компаний, нам нужно было:
                        </CommonUsualText>
                    </div>
                    <div className="gens-task__list">
                        <CommonOlList CommonOlList={taskList} />
                    </div>
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Task;
